import { api } from "./api";
import type { LerunIssuer } from "./lerun-types";

export async function loadLerunIssuer(
  showCached: (data: LerunIssuer) => void,
): Promise<LerunIssuer> {
  const cached = await api.lerunIssuer();
  showCached(cached);
  return cached.configured ? api.refreshLerunIssuer() : cached;
}
